import { useEffect , React } from "react";
import { BrowserRouter as Router, Routes, Route , useLocation } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Conatct from "./pages/Conatct";
import Blog from "./pages/Blog";
import Booking from "./pages/Booking";
import Gallery from "./pages/Gallery";
import TermsAndConditions from "./pages/TermsAndConditions";
import ViewBlog from "./pages/ViewBlog";
import RoomBooking from "./pages/RoomBooking";
import Checkout from "./pages/Checkout";
import Confirmation from "./pages/Confirmation";

// ✅ ScrollToTop Component
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function Layout() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />

      {/* All routes go here */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Conatct />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/view-blog/:id" element={<ViewBlog />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/room-booking" element={<RoomBooking />} />
        <Route path="/booking/checkout" element={<Checkout />} />
        <Route path="/booking/confirmation" element={<Confirmation />} />
        <Route path="/terms-conditions" element={<TermsAndConditions />} />
        </Routes>
      <Footer />
    </Router>
  )
}

export default Layout